import { useSelector } from "react-redux";

import { SaleType } from "constants/sale";
import { getCurrentSaleType } from "selectors";

// Returns the provided sale type, or falls back to the current sale's sale type
// when we are inside a sale context.
export function useResolveSaleType(
  override?: SaleType | null,
): SaleType | null {
  const currentSaleType = useSelector(getCurrentSaleType);
  return override ?? currentSaleType;
}
